import React, { useState, useEffect } from "react";
import "../styles/Header.css";

function Header() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const [activeSection, setActiveSection] = useState("gioi-thieu");

    // Handle scrolling effect
    useEffect(() => {
        const handleScroll = () => {
            // Set header style when scrolled
            if (window.scrollY > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }

            // Update active section based on scroll position
            const sections = ["gioi-thieu", "showroom", "lien-he"];
            const currentPosition = window.scrollY + 100;

            for (const section of sections) {
                const element = document.getElementById(section);
                if (element) {
                    const offsetTop = element.offsetTop;
                    const height = element.offsetHeight;

                    if (
                        currentPosition >= offsetTop &&
                        currentPosition < offsetTop + height
                    ) {
                        setActiveSection(section);
                        break;
                    }
                }
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    // Close menu when clicking outside
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (
                menuOpen &&
                !e.target.closest(".main-nav") &&
                !e.target.closest(".mobile-menu-btn")
            ) {
                setMenuOpen(false);
            }
        };

        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, [menuOpen]);

    // Prevent body scroll when menu is open on mobile
    useEffect(() => {
        if (menuOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }

        return () => {
            document.body.style.overflow = "";
        };
    }, [menuOpen]);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const handleNavClick = (section) => {
        setActiveSection(section);
        setMenuOpen(false);
    };

    return (
        <header className={`header ${scrolled ? "scrolled" : ""}`}>
            <div className="logo">
                <a href="/">
                    <img
                        src="/images/logo-HBC.png"
                        alt="Logo Công ty HBC"
                        className="logo-image"
                    />
                </a>
            </div>

            <button
                className="mobile-menu-btn"
                onClick={toggleMenu}
                aria-label={menuOpen ? "Đóng menu" : "Mở menu"}
            >
                {menuOpen ? "✕" : "☰"}
            </button>

            <nav className={`main-nav ${menuOpen ? "open" : ""}`}>
                <ul>
                    <li>
                        <a
                            href="#gioi-thieu"
                            onClick={() => handleNavClick("gioi-thieu")}
                            className={
                                activeSection === "gioi-thieu" ? "active" : ""
                            }
                        >
                            Giới thiệu
                        </a>
                    </li>
                    <li>
                        <a
                            href="#showroom"
                            onClick={() => handleNavClick("showroom")}
                            className={
                                activeSection === "showroom" ? "active" : ""
                            }
                        >
                            Trạm dịch vụ
                        </a>
                    </li>
                    <li>
                        <a
                            href="#lien-he"
                            onClick={() => handleNavClick("lien-he")}
                            className={
                                activeSection === "lien-he" ? "active" : ""
                            }
                        >
                            Liên hệ
                        </a>
                    </li>
                </ul>
            </nav>

            {menuOpen && (
                <div
                    className={`overlay ${menuOpen ? "show" : ""}`}
                    onClick={() => setMenuOpen(false)}
                ></div>
            )}
        </header>
    );
}

export default Header;
